import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { API_ACTION, API_SCOPE, ApiAction, ApiScope } from 'src/app/shared/interceptor/interceptor.token';
import { CommonApiResponse } from 'src/app/shared/interface/common.interface';
import { environment as ENV } from 'src/environments/environment';
import {
  CreateScenarioApiResponse,
  CreateScenarioParam,
  Scenario,
  ScenarioApiResponse,
  ScenarioListApiResponse,
} from '../interface/scenario.interface';

@Injectable({
  providedIn: 'root',
})
export class ScenarioApi {
  constructor(private _http: HttpClient) {}

  /** Get all scenarios under an order */
  getScenarioList(orderId: string): Observable<Scenario[]> {
    return this._http
      .get<
        CommonApiResponse<ScenarioListApiResponse>
      >(`${ENV.backendBaseUrl}/api/orders/${orderId}/scenarios`, { context: new HttpContext().set(API_ACTION, ApiAction.READ).set(API_SCOPE, ApiScope.ORDER) })
      .pipe(map((res) => res.data.scenarios));
  }

  /** Get a specific scenarios under an order */
  getScenario(scenarioId: string): Observable<Scenario> {
    return this._http
      .get<
        CommonApiResponse<ScenarioApiResponse>
      >(`${ENV.backendBaseUrl}/api/scenarios/${scenarioId}`, { context: new HttpContext().set(API_ACTION, ApiAction.READ).set(API_SCOPE, ApiScope.ORDER) })
      .pipe(map((res) => res.data.scenario));
  }

  /** Create new scenario */
  createScenario(params: CreateScenarioParam, orderId: string): Observable<Scenario> {
    const httpParams: any = {
      ...params,
    };
    return this._http
      .post<
        CommonApiResponse<CreateScenarioApiResponse>
      >(`${ENV.backendBaseUrl}/api/orders/${orderId}/scenarios`, httpParams, { context: new HttpContext().set(API_ACTION, ApiAction.WRITE).set(API_SCOPE, ApiScope.ORDER) })
      .pipe(map((res) => res.data.scenario));
  }

  /** Delete a scenario */
  deleteScenario(scenarioId: string): Observable<unknown> {
    return this._http.delete<CommonApiResponse<null>>(`${ENV.backendBaseUrl}/api/scenarios/${scenarioId}`, {
      context: new HttpContext().set(API_ACTION, ApiAction.WRITE).set(API_SCOPE, ApiScope.ORDER),
    });
  }

  /**update scenario */
  updateScenario(scenarioId: string, params: Partial<Scenario>): Observable<boolean> {
    return this._http
      .patch<
        CommonApiResponse<Scenario>
      >(`${ENV.backendBaseUrl}/api/scenarios/${scenarioId}`, params, { context: new HttpContext().set(API_ACTION, ApiAction.WRITE).set(API_SCOPE, ApiScope.ORDER) })
      .pipe(map(() => true));
  }
}
